import React, { useState, useEffect } from 'react';
import { RadioGroup as RadioGroupPoi } from '@Sage/hoi-poi-ui';

function RadioGroup({ inputs, ...props }) {
    const [options, setOptions] = useState([]);
    useEffect(() => {
        setOptions(inputs.map((input) => ({ label: input.label, value: input.name })));
    }, [inputs]);
    return <RadioGroupPoi options={options} {...props} isFullWidth={false} />;
}

export default RadioGroup;
